import { Button } from "@beringlab/ui"
import { useTranslation } from "react-i18next"
import { Link } from "@tanstack/react-router"

const NotFoundPage = () => {
  const { t } = useTranslation()
  return (
    <main className="grid min-h-full place-items-center bg-card px-6 py-24 sm:py-32 lg:px-8">
      <div className="text-center">
        <p className="text-base font-semibold text-key-color">404</p>
        <h1 className="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-6 text-base leading-7 text-gray-600">
          {t("common.notFound")}
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <Button asChild>
            <Link to="/">{t("common.goBack")}</Link>
          </Button>
        </div>
      </div>
    </main>
  )
}

export default NotFoundPage
